import { createAction, createAsyncThunk, createSlice, Dispatch, Store } from "@reduxjs/toolkit";
import { LoadingState } from "http/model";

interface TableScreenState {
  data: any;
  loading: LoadingState;
}

type FetchRowsFunction = (params: any, dispatch: Dispatch<any>, store: Store<any>) => Promise<any>;

type FetchRowsParams = {
  fetchRowsFunction: FetchRowsFunction;
  params: any;
};

export const fetchRows = createAsyncThunk(
  "tableScreen/fetchRows",
  async (params: FetchRowsParams, { dispatch, getState }) => {
    const response = await params.fetchRowsFunction(
      params.params,
      dispatch,
      getState() as Store<any>
    );
    return response;
  }
);

export const removeRow = createAction(
  "tableScreen/removeRow",
  (filterCallback: (row: any) => boolean) => {
    return { payload: { filterCallback } };
  }
);

export const resetTableScreen = createAction("tableScreen/reset");

const initialState = {
  data: null,
  loading: LoadingState.initial,
} satisfies TableScreenState as TableScreenState;

const tableScreenSlice = createSlice({
  name: "tableScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchRows.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = LoadingState.loaded;
    });

    builder.addCase(fetchRows.pending, (state, action) => {
      state.loading = LoadingState.loading;
    });

    builder.addCase(fetchRows.rejected, (state, action) => {
      state.loading = LoadingState.failed;
    });

    builder.addCase(resetTableScreen, (state, action) => {
      state.data = null;
      state.loading = LoadingState.initial;
    });

    builder.addCase(removeRow, (state, action) => {
      if (action.payload?.filterCallback) {
        state.data = state.data.filter((row: any) => action.payload?.filterCallback(row));
      }
    });
  },
  selectors: {
    selectTableScreenData: (state: TableScreenState) => state.data,
    selectTableScreenLoading: (state: TableScreenState) => state.loading,
  },
});

export const { selectTableScreenData, selectTableScreenLoading } = tableScreenSlice.selectors;
export default tableScreenSlice.reducer;
